import { render, staticRenderFns } from "./modal-login.vue?vue&type=template&id=05d3077c&scoped=true"
import script from "./modal-login.vue?vue&type=script&lang=js"
export * from "./modal-login.vue?vue&type=script&lang=js"
import style0 from "./modal-login.vue?vue&type=style&index=0&id=05d3077c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d3077c",
  null
  
)

export default component.exports